import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { BUSINESS } from "../data/site";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="py-24 bg-white text-center" data-testid="not-found">
        <div className="max-w-xl mx-auto px-4">
          <p className="font-heading font-extrabold text-7xl text-sky-600/20">404</p>
          <h1 className="font-heading font-bold text-3xl text-slate-900 mt-2">This page went out with the trash.</h1>
          <p className="mt-3 text-slate-600">The page you're looking for doesn't exist — but your dumpster is easy to find.</p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/request-a-dumpster" className="px-7 py-3.5 rounded-lg bg-sky-600 hover:bg-sky-700 text-white font-heading font-semibold transition-colors" data-testid="nf-request">
              Request a Dumpster
            </Link>
            <Link to="/" className="px-7 py-3.5 rounded-lg border-2 border-slate-900 text-slate-900 font-heading font-semibold hover:bg-slate-900 hover:text-white transition-all" data-testid="nf-home">
              Back to Home
            </Link>
          </div>
          <p className="mt-6 text-sm text-slate-500">Or call us: <a href={BUSINESS.phoneHref} className="font-semibold text-sky-700">{BUSINESS.phone}</a></p>
        </div>
      </section>
    </>
  );
}
